<div class="consent-container">
  @if (consentNotSet) {
    <p class="consent-not-set">Marketing consents have not been created for this player</p>
  }
  @if (fg) {
    <form [formGroup]="fg" (submit)="update()">
      <div class="consent-container">
        <p class="consents-header">Games</p>
        <table class="consent-table">
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="gamesEmail">Email</label>
                <mat-checkbox data-id="gamesEmailCheckbox" id="gamesEmail" formControlName="gamesEmail"></mat-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="gamesSms">SMS</label>
                <mat-checkbox data-id="gamesSmsCheckbox" id="gamesSms" formControlName="gamesSms"></mat-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="gamesCall">Call</label>
                <mat-checkbox data-id="gamesCallCheckbox" id="gamesCall" formControlName="gamesCall"></mat-checkbox>
              </div>
            </td>
          </tr>
        </table>
        <p class="consents-header">Lotto</p>
        <table class="consent-table">
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="lottoEmail">Email</label>
                <mat-checkbox data-id="lottoEmailCheckbox" id="lottoEmail" formControlName="lottoEmail"></mat-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="lottoSms">SMS</label>
                <mat-checkbox data-id="lottoSmsCheckbox" id="lottoSms" formControlName="lottoSms"></mat-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="consent-elements-container">
                <label for="lottoCall">Call</label>
                <mat-checkbox data-id="lottoCallCheckbox" id="lottoCall" formControlName="lottoCall"></mat-checkbox>
              </div>
            </td>
          </tr>
        </table>
        @if (!!confirmationDate) {
          <p data-id="approvedByText" class="consents-confirmation">
            {{ 'Approved by player on ' + (confirmationDate | date: 'dd MMM yyyy HH:mm:ss' : '+0000') }}
          </p>
        }
        @if (!confirmationDate) {
          <p class="consents-confirmation">The player has not yet confirmed the new consents</p>
        }
        @if (!!dateUpdated) {
          <p class="consents-confirmation">
            {{ 'Last updated on ' + (dateUpdated | date: 'dd MMM yyyy HH:mm:ss' : '+0000') }}
          </p>
        }
      </div>
      <div class="edit-container">
        @if (editMode) {
          @if (updatingInProgress) {
            <mat-spinner class="spinner-block" [diameter]="20"></mat-spinner>
          }
          @if (!success && !updatingInProgress) {
            <button data-id="saveMarketingConsentBtn" mat-stroked-button color="primary" type="submit">Save</button>
          }
          @if (!success && !updatingInProgress) {
            <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        }
        @if (!editMode) {
          @if (!success) {
            <button
              data-id="editMarketingConsentBtn"
              mat-icon-button
              color="primary"
              type="submit"
              (click)="toggleEditMode()">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (success) {
            <strong class="green">Changes saved</strong>
          }
        }
      </div>
    </form>
  }
</div>
